module.exports = __webpack_public_path__ + "static/map-bg-8adae11df8f34177d2aaa3e42ad37da5.jpg";